<template>
    <textarea v-bind:name="name" class="form-control m-input" :class="inputClass" v-bind:id="id" v-bind:placeholder="placeholder" v-bind:value="value">
    </textarea>
</template>

<script>
export default {
  name: 'TextareaComponent',
  props: ['id', 'value', 'name', 'placeholder', 'type', 'inputClass']
}
</script>



// WEBPACK FOOTER //
// src/components/core/form/inputs/TextareaComponent.vue